<div class="block w-full h-full p-4 sm:p-8 bg-white rounded-lg shadow-axleBlue dark:bg-primary-950">
  <h5 class="text-xl font-medium leading-none text-gray-900 dark:text-white mb-1">{{ header }}</h5>
  <p class="font-normal text-zinc-500 dark:text-gray-400 mb-6 text-base xl:text-l">
    {{ subheader }}
  </p>
  <ng-content select="[content]"></ng-content>
</div>
